import React from "react";
class Button extends React.Component {
  // list of states
  constructor(props) {
    super(props);
    this.state = {
      status: false,
    };
  }
  render() {
    if (this.props.isClickable == true) {
      return (
        <a
          target={this.props.target == "_blank" ? "_blank" : "_self"}
          onClick={this.props.click}
          className="btn primary"
          style={this.props.style ? this.props.style : {}}
        >
          {this.props.children}
        </a>
      );
    } else {
      return (
        <a
          target={this.props.target == "_blank" ? "_blank" : "_self"}
          href={this.props.to}
          className="btn primary"
          style={this.props.style ? this.props.style : {}}
        >
          {this.props.children}
        </a>
      );
    }
  }
}
export default Button;